import u from 'umbrellajs';
import _e from 'common/localeUtil';
import {
	addJSToTemplate,
	loadTemplate,
	getTemplateHTML,
	applyExtraDataToEditorRight,
	setDataGMUserTypeToHTML,
	convertSlateToHTML
} from './utils';
import { BRANDING_TYPE, CONTACT_DISCLAIMER_DEFAULT } from '../constants';
import {
	findGrapesJSComponents,
	setAllChildComponentsReadOnly,
	setReadOnlyComponent
} from './domUtils';

const DEFAULT_AVATAR =
	'https://static.goalsmapper.com/public/platform/agent_website/deault_avatar.png';

const getDefaultAvatar = () => {
	const { locale } = window.adviserData;
	if (locale === 'th-TH') {
		return 'https://static.goalsmapper.com/public/platform/agent_website/thailandGuy.png';
	}
	return DEFAULT_AVATAR;
};

const addRemoveGrapesJSButtons = () => {
	// Add tooltip to top buttons
	u('span[class*="fa-undo"]').attr('title', 'Undo');
	u('span[class*="fa-repeat"]').attr('title', 'Redo');
	u('.gjs-pn-btn.fa-desktop').attr('title', 'Desktop');
	u('.gjs-pn-btn.fa-tablet').attr('title', 'Tablet');
	u('.gjs-pn-btn.fa-mobile').attr('title', 'Mobile');

	u('#gjs-sm-color .gjs-field-color').attr('title', 'Font color');
	u('#gjs-sm-background-color .gjs-field-color').attr('title', 'Background color');
	u('#gjs-sm-border-color .gjs-field-color').attr('title', 'Border color');
	u('#gjs-sm-border-width .gjs-select').attr('title', 'Border width');

	u('#gjs-sm-font-weight').attr('title', 'Font weight');
	u('#gjs-sm-font-size').attr('title', 'Font size');
	u('#gjs-sm-font-family').attr('title', 'Font family');

	u('.fa-align-left').attr('title', 'Left');
	u('.fa-align-center').attr('title', 'Center');
	u('.fa-align-right').attr('title', 'Right');
	u('.fa-align-justify').attr('title', 'Justify');

	//   document.querySelector('span[title="View components"]').click();

	//   panelManager.removeButton("views", "open-layers");
	//   panelManager.removeButton("views", "open-blocks");
	//   panelManager.removeButton("views", "open-tm");

	// const panelManager = editor.Panels;
	// const views = panelManager.getPanel("views");
	// const panelOptions = panelManager.getPanel("options");

	// const panelCommands = panelManager.getPanel("commands");
	// const panelViewsContainer = panelManager.getPanel("views-container");
	// const panelDevicesC = panelManager.getPanel("devices-c");

	// panelManager.removeButton("options", "canvas-clear");
	// // panelManager.removeButton("options", "export-template");
	// // panelManager.removeButton("options", "gjs-open-import-webpage");
	// panelManager.removeButton("options", "redo");
	// panelManager.removeButton("options", "undo");
	// // panelManager.removeButton("options", "sw-visibility");

	// panelManager.removeButton("views", "open-layers");
	// panelManager.removeButton("views", "open-blocks");
	// panelManager.removeButton("views", "open-tm");
};

const removeAllFullScreenStyles = () => {
	const styles = window.grapesjs.Canvas.getDocument()?.body.querySelectorAll('style');
	if (styles) {
		// console.log('removeAllFullScreenStyles', styles.length);
		for (let i = styles.length - 1; i >= 0; i -= 1) {
			const style = styles[i];
			const text = style.textContent;
			if (text.includes('full-screen')) {
				// console.log('removeAllFullScreenStyles', style.textContent);
				style.remove();
			}
		}
	}
	window.GM_BACKGROUND_IMAGE_URL = null;
};

export const applySampleDataIntoWebsiteHtml = (html, template, adviserInfo) => {
	let resultHtml = html;
	console.log('applySampleDataIntoWebsiteHtml', template, adviserInfo);
	resultHtml = resultHtml.replace(/{MENU_MAIN}/g, _e('main'));
	resultHtml = resultHtml.replace(/{MENU_VIDEOS}/g, _e('videos'));
	resultHtml = resultHtml.replace(/{MENU_ABOUT}/g, _e('my_story'));
	resultHtml = resultHtml.replace(/{MENU_SERVICES}/g, _e('my_services'));
	resultHtml = resultHtml.replace(/{MENU_ACHIEVEMENTS}/g, _e('my_achievements'));
	resultHtml = resultHtml.replace(/{MENU_TESTIMONIALS}/g, _e('testimonials'));
	resultHtml = resultHtml.replace(/{MENU_WIDGETS}/g, _e('tools'));
	resultHtml = resultHtml.replace(/{MENU_CONTACT}/g, _e('contact'));
	resultHtml = resultHtml.replace(/{MENU_VIDEO}/g, _e('video'));
	resultHtml = resultHtml.replace(/{MENU_DUMMY1}/g, `${_e('background')} 1`);
	resultHtml = resultHtml.replace(/{MENU_DUMMY2}/g, `${_e('background')} 2`);
	resultHtml = resultHtml.replace(/{NAME}/g, _e('name'));
	resultHtml = resultHtml.replace(/{NAMEREQUIRED}/g, _e('name_required'));
	resultHtml = resultHtml.replace(/{MESSAGE}/g, _e('message'));
	resultHtml = resultHtml.replace(/{MESSAGEHERE}/g, _e('message_here'));
	resultHtml = resultHtml.replace(/{MOBILE}/g, _e('mobile'));
	resultHtml = resultHtml.replace(/{MOBILEREQUIRED}/g, _e('mobile_required'));
	resultHtml = resultHtml.replace(/{EMAIL}/g, _e('email'));
	resultHtml = resultHtml.replace(/{EMAILREQUIRED}/g, _e('email_required'));
	resultHtml = resultHtml.replace(/{WHAT_HAPPY_CLIENTS_SAY}/g, _e('what_happy_clients_say'));
	resultHtml = resultHtml.replace(/{CONTACTME}/g, _e('contact_me'));
	resultHtml = resultHtml.replace(/{PERSONAL_WEALTH_MANAGER}/g, _e('personal_wealth_manager'));
	resultHtml = resultHtml.replace(/{LETSTALK}/g, _e('lets_talk'));
	resultHtml = resultHtml.replace(/{DROP_A_MESSAGE}/g, _e('drop_a_message'));
	resultHtml = resultHtml.replace(/{FINANCIAL_SPECIALIST}/g, _e('financial_specialist'));
	resultHtml = resultHtml.replace(/{PHONE}/g, _e('phone'));

	console.log(_e('tagline'));
	resultHtml = resultHtml.replace(/{TAGLINE}/g, _e('tagline'));
	resultHtml = resultHtml.replace(/{TAGLINE_NO_BR}/g, _e('tagline_no_br'));
	resultHtml = resultHtml.replace(/{TAGLINE_DESC}/g, _e('tagline_desc'));
	resultHtml = resultHtml.replace(/{ABOUT_TITLE}/g, _e('i_am_lisa'));
	resultHtml = resultHtml.replace(/{ABOUT}/g, _e('about'));
	resultHtml = resultHtml.replace(/{HELLO_I_AM}/g, _e('hello_i_am'));
	resultHtml = resultHtml.replace(/{ABOUT_BODY}/g, _e('about_body'));
	resultHtml = resultHtml.replace(/{SERVICE_SUBTITLE}/g, _e('service_subtitle'));
	resultHtml = resultHtml.replace(/{SERVICE_TITLE1}/g, _e('save'));
	resultHtml = resultHtml.replace(/{SERVICE_BODY1}/g, _e('service_body1'));
	resultHtml = resultHtml.replace(/{SERVICE_TITLE2}/g, _e('protect'));
	resultHtml = resultHtml.replace(/{SERVICE_BODY2}/g, _e('service_body2'));
	resultHtml = resultHtml.replace(/{SERVICE_TITLE3}/g, _e('grow'));
	resultHtml = resultHtml.replace(/{SERVICE_BODY3}/g, _e('service_body3'));
	resultHtml = resultHtml.replace(/{SERVICE_TITLE4}/g, _e('plan'));
	resultHtml = resultHtml.replace(/{SERVICE_BODY4}/g, _e('service_body4'));

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE1}/g, _e('achievement1_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_POSITION1}/g, _e('achievement1_position'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC1}/g, '2012');
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DETAIL1}/g, _e('achievement1_description'));

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE2}/g, _e('achievement2_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_POSITION2}/g, _e('achievement2_position'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC2}/g, '2013 to 2015');
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DETAIL2}/g, _e('achievement2_description'));

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE3}/g, _e('achievement3_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_POSITION3}/g, _e('achievement3_position'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC3}/g, '2016 to 2018');
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DETAIL3}/g, _e('achievement3_description'));

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE4}/g, _e('achievement4_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC4}/g, '2016');

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE5}/g, _e('achievement5_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC5}/g, '2019');

	resultHtml = resultHtml.replace(/{ACHIEVEMENT_TITLE6}/g, _e('achievement6_title'));
	resultHtml = resultHtml.replace(/{ACHIEVEMENT_DESC6}/g, '2015, 2019');

	// Contact Disclaimer
	const {
		preferences: { other_settings },
		first_name,
		last_name
	} = adviserInfo.adviserData;
	let { contact_disclaimer } = other_settings;
	console.log('DISCALIMER REPLACE', {
		other_settings,
		contact_disclaimer
	});
	if (!contact_disclaimer) {
		const contact_disclaimer_json = JSON.stringify(CONTACT_DISCLAIMER_DEFAULT());
		contact_disclaimer = JSON.parse(
			contact_disclaimer_json.replaceAll('FIRSTNAMELASTNAME', `${first_name} ${last_name}`)
		);
	}
	resultHtml = resultHtml.replace(
		/{CHECKBOX_PRIVACY_POLICY}/g,
		`<div class="field">
		  <div class="pretty p-default p-curve">
		    <input type="checkbox" id="privacy" />
		    <div class="state p-primary">
		      <label>
		        ${convertSlateToHTML(contact_disclaimer)
					.replace(/<p/g, '<span')
					.replace(/\/p>/g, '/span>')}
		      </label>
		    </div>
		  </div>
		  <p class="help help-privacy form-helper is-danger is-hidden">
		    ${_e('check_box_required')}
		  </p>
		</div>`
	);

	// disable configure background for template 11 Disclaimer
	let additionParams = '';
	if (window.currentTemplate === 'template11') {
		additionParams = 'data-background-edit-disabled="true"';
	}

	// Website Disclaimer
	resultHtml = resultHtml.replace(
		/{DISCLAIMER}/g,
		`<div class="disclaimer section" id="section-disclaimer" data-configurable-disabled="true" ${additionParams}>
				<div class="container">
					<div class="columns">
						<div class="column">
							${_e('footer_text')}
						</div>
					</div>
				</div>
			</div>`
	);

	resultHtml = resultHtml.replace(
		/{BACK_TO_TOP_BUTTON}/g,
		`<a href="javascript:backToTopFunction();" class="backToTop">
				<img data-id="backToTop"
					src="https://static.goalsmapper.com/public/platform/agent_website/others/scroll-to-top.png"
				/>
			</a>`
	);

	resultHtml = resultHtml.replace(
		/{FORM_SUBMIT_STATUS}/g,
		`<article class="message is-danger is-hidden form-status-cantsend">
			<div class="message-body">
				${_e('preview_staging_environment_message')}
			</div>
		</article>
		<article class="message is-success is-hidden form-status-ok">
			<div class="message-body">
				${_e('message_successfully_sent')}
			</div>
		</article>`
	);

	resultHtml = resultHtml.replace(
		/{FORM_SUBMIT_BUTTON}/g,
		`<div class="field is-grouped">
				<div class="control">
						<button
										class="button bt1 is-link"
										onclick="submitForm('page')"
						>
								${_e('submit')}
						</button>
				</div>
		</div>`
	);

	resultHtml = resultHtml.replace(
		/{RECAPTCHA}/g,
		`<div id='recaptcha1' class="g-recaptcha"
				data-sitekey="${process.env.REACT_APP_RECAPTCHA_KEY}"
				data-callback="doSubmitForm"
				data-size="invisible"
				data-expired-callback="recaptchaExpiredCallback"
				data-error-callback="recaptchErrorCallback"></div>`
	);
	const videoContainerClassName = template === 'template3' ? 'containertemplate3' : 'container';
	resultHtml = resultHtml.replace(
		/{VIDEOS_SECTION}/g,
		`<!-- Video -->
		<div class="videos section" id="section-videos" data-layout-col="2">
			<div class="${videoContainerClassName}">
				<div class="columns">
					<h3 class="column header">
						${_e('videos')}
					</h3>
				</div>
			</div>
			<div class="container">
				<div class="layoutable columns is-multiline videos-wrapper min-1-row">
					<div class="column video" data-gjs-highlightable="true">
						<div class="video-wrapper">
							<iframe
								allowfullscreen="allowfullscreen"
								src="https://www.youtube.com/embed/3y0GnTbAMLU"
							></iframe>
						</div>
					</div>
					<div class="column video" data-gjs-highlightable="true">
						<div class="video-wrapper">
							<iframe src="https://player.vimeo.com/video/290833426" allowfullscreen></iframe>
						</div>
					</div>
				</div>
			</div>
			<div class="video-item-add-button"></div>
		</div>`
	);

	resultHtml = resultHtml.replace(
		/{EBOOK_SECTION}/g,
		`<div class="section-ebook section" id="section-ebook">
			<div class="container">
				<div class="columns">
					<div class="column is-5 ebook-left">
						<div class="image-burst-wrapper">
							<div
								class="image-wrapper"
								data-image-props='{"width": 320, "height": 430}'
							>
								<img
									class="avatar"
									src="https://static.goalsmapper.com/public/platform/branding/ebook-2020.png"
								/>
							</div>
						</div>
					</div>
					<div class="column is-7 ebook-right">
						<div class="ebook-right-wrapper">
							<div class="ebook-title">
								${_e('yours_free')}
							</div>
							<div class="ebook-subtitle">
								${_e('ebook_desc')}
							</div>
							<div class="ebook-disclaimer-wrapper">
								<div class="ebook-download-button-wrapper">
									<a class="ebook-download-button">
										${_e('download_ebook_btn')}
									</a>
								</div>
								<div class="ebook-disclaimer">
									${_e('download_ebook_subtitle')}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal ebook-modal">
				<div class="modal-background"></div>
				<div class="modal-card">
					<header class="modal-card-head">
						<p class="modal-card-title">${_e('financial_planning_ebook')}</p>
						<button class="delete" aria-label="close"></button>
					</header>
					<section class="modal-card-body">
						<!-- Content ... -->
						<div class="popup-message">${_e('financial_planning_ebook_desc')}</div>
						<form class="form-ebook" onsubmit="return false" _lpchecked="1">
							<!-- Name -->
							<div class="field">
								<label class="label form-label">${_e('name')} *</label>
								<div class="control">
									<input
										class="input"
										type="text"
										placeholder="${_e('name')}"
										id="ebook-form-name"
										required=""
									/>
								</div>
								<p class="help help-name form-helper is-danger is-hidden">
									${_e('name_required')}
								</p>
							</div>
							<!-- Mobile -->
							<div class="field">
								<label class="label form-label">${_e('mobile')} *</label>
								<div class="control">
									<input
										class="input"
										type="tel"
										placeholder="${_e('mobile')}"
										id="ebook-form-mobile"
									/>
								</div>
								<p class="help help-mobile form-helper is-danger is-hidden">
									${_e('mobile_required')}
								</p>
							</div>
							<!-- Email -->
							<div class="field">
								<label class="label form-label">${_e('email')} *</label>
								<div class="control">
									<input
										class="input"
										type="email"
										placeholder="${_e('email')}"
										id="ebook-form-email"
									/>
								</div>
								<p class="help help-email form-helper is-danger is-hidden">
									${_e('email_required')}
								</p>
							</div>
							<div class="field">
								<div class="pretty p-default p-curve">
									<input type="checkbox" id="ebook-form-privacy" />
									<div class="state p-primary">
										<label>
											${_e('content_form_disclaimer_desc')}
											<br />
											<ul>
												<li>${_e('perform_holistic_review')}</li>
												<li>${_e('send_marketing_information')}</li>
												<li>${_e('comply_laws')}</li>
												<li>${_e('notify_promotions')}</li>
											</ul>
											${_e('contact_information_submit_message')}
											<br /><br />
											${_e('proceed_if_agree_contact')}
										</label>
									</div>
								</div>
								<p class="help help-privacy form-helper is-danger is-hidden">
									${_e('check_box_required')}
								</p>
							</div>
							<div class="field is-grouped">
								<div class="control">
									<button class="button is-link" onclick="submitForm('form-ebook')">
										${_e('submit')}
									</button>
								</div>
							</div>
							<article class="message is-danger is-hidden form-status-cantsend">
								<div class="message-body">
									${_e('preview_staging_environment_message')}
								</div>
							</article>
							<article class="message is-success is-hidden form-status-ok">
								<div class="message-body">
									${_e('message_check_email_download_link')}
								</div>
							</article>
							<div
								id="recaptcha"
								class="g-recaptcha"
								data-badge="bottomright"
								data-sitekey="${process.env.REACT_APP_RECAPTCHA_KEY}"
								data-callback="doSubmitForm"
								data-expired-callback="recaptchaExpiredCallback"
								data-error-callback="recaptchErrorCallback"
							></div>
						</form>
					</section>
				</div>
			</div>
		</div>`
	);
	resultHtml = resultHtml.replace(
		/{EBOOK_MENU}/g,
		`<div class="navbar-item nav-link menu-ebook">
				<a href="#section-ebook">${_e('ebook')}</a>
			</div>`
	);

	// Need to refactor all social links
	const socials = ` <a class="facebook" href="https://facebook.com" target="_blank">
											<i class="fab fa-facebook-f"></i>
										</a>
										<a class="twitter" href="https://twitter.com" target="_blank">
											<i class="fab fa-twitter"></i>
										</a>
										<a class="linkedin" href="https://linkedin.com" target="_blank">
											<i class="fab fa-linkedin-in"></i>
										</a>
										<a class="instagram" href="https://instagram.com" target="_blank">
											<i class="fab fa-instagram"></i>
										</a>
										<a class="whatsapp" href="https://whatsapp.com" target="_blank">
											<i class="fab fa-whatsapp"></i>
										</a>
										<a class="telegram" href="https://www.telegram.org" target="_blank">
											<i class="fab fa-telegram"></i>
										</a>`;
	resultHtml = resultHtml.replace(
		/{SOCIAL_LINKS}/g,
		`<div class="social">
			${socials}
		</div>`
	);
	resultHtml = resultHtml.replace(
		/{SOCIAL_LINKS_MOBILE}/g,
		`<div class="social mobile">
			${socials}
		</div>`
	);

	resultHtml = resultHtml.replace(
		/{RESEARCHER_AUTHOR_SPEAKER}/g,
		_e('researcher_author_speaker')
	);

	return resultHtml;
};

export const applyAdviserDataIntoWebsiteHtml = (html, template, adviserInfo = {}) => {
	let resultHtml = html;
	const { adviserData = window.adviserData, extraProfile = {}, contactForm = {} } = adviserInfo;
	if (adviserData) {
		// console.log('applyAdviserDataIntoWebsiteHtml', resultHtml);
		const { first_name: firstName, last_name: lastName, id, country } = adviserData;

		const profileUrl =
			extraProfile.profile_picture || adviserData.profile_picture || getDefaultAvatar();
		const mobileNumber = contactForm.mobile_number || adviserData.mobile_number || '';
		const email = contactForm.receiving_email || adviserData.email;

		resultHtml = resultHtml.replace(/FIRSTNAME/g, firstName);
		resultHtml = resultHtml.replace(/LASTNAME/g, lastName);
		resultHtml = resultHtml.replace(/REALEMAIL/g, email);

		resultHtml = resultHtml.replace(/REALPHONENUMBER/g, mobileNumber);

		resultHtml = resultHtml.replace(/AVATARIMAGE/g, profileUrl);

		let realWidgetEduBaseUrl = '';
		let realWidgetEduRetirementUrl = '';
		let realWidgetEduInsuranceUrl = '';
		if (
			window.location.hostname.includes('localhost') ||
			window.location.hostname.includes('customise-new')
		) {
			realWidgetEduBaseUrl = 'https://widgets-new.goalsmapper.com/oversea-study';
			realWidgetEduRetirementUrl = `${process.env.REACT_APP_WIDGET_URL}/retirement-planner`;
			realWidgetEduInsuranceUrl = `${process.env.REACT_APP_WIDGET_URL}/insurance-planner`;
		}
		resultHtml = resultHtml.replace(
			/REALWIDGETEDU/g,
			`${realWidgetEduBaseUrl}?agent-id=${id}&country=${country}`
		);
		resultHtml = resultHtml.replace(
			/REALWIDGETRETIREMENT/g,
			`${realWidgetEduRetirementUrl}?agent-id=${id}&country=${country}`
		);
		resultHtml = resultHtml.replace(
			/REALWIDGETINSURANCE/g,
			`${realWidgetEduInsuranceUrl}?agent-id=${id}&country=${country}`
		);
	}
	return resultHtml;
};

export const applyDataIntoCoverHtml = html => {
	const now = new Date();
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	const fullDate = now.toLocaleDateString(undefined, options);
	return html.replace(/TODAYHERE/g, fullDate).replace(/CURRENT_YEAR/g, now.getFullYear());
};

const applyDataIntoEbookIntroHtml = (html, template, adviserInfo) => {
	const { adviserData = window.adviserData, extraProfile = {} } = adviserInfo;
	console.log('applyDataIntoEbookIntroHtml', adviserData);

	let resultHtml = html;
	const { first_name: firstName, last_name: lastName, locale, accreditations = [] } = adviserData;
	let { designation } = adviserData;
	designation = designation || 'Director, Advisory';
	const profileUrl =
		extraProfile.profile_picture || adviserData.profile_picture || getDefaultAvatar();
	resultHtml = resultHtml.replace(/{AVATARIMAGE}/g, profileUrl);

	resultHtml = resultHtml.replace(/{PROFILE_NAME}/g, `${firstName}<br />${lastName}`);
	resultHtml = resultHtml.replace(/{PROFILE_PROFESSON}/g, `${designation}`);

	let joinedAccredits = `ChFC /S. CLU /S. AEPP;`;
	if (accreditations && accreditations.length > 0) {
		joinedAccredits = accreditations.join(' / ');
	}
	resultHtml = resultHtml.replace(/{PROFILE_ACCOLADE1}/g, joinedAccredits);
	resultHtml = resultHtml.replace(/{PROFILE_ACCOLADE2}/g, `Court of the Table 2016`);
	resultHtml = resultHtml.replace(
		/{PROFILE_ACCOLADE3}/g,
		`Million Dollar Round Table 2009 – 2018 (Life Member)`
	);

	resultHtml = resultHtml.replace(/{EBOOKINTRO_TEXT_LEFT}/g, _e('ebook_intro_text_left'));
	resultHtml = resultHtml.replace(/{EBOOKINTRO_TEXT_RIGHT}/g, _e('ebook_intro_text_right'));
	// const goalsMapping = `<span class="blue-bold gjs-readonly">${_e(
	// 	'goals'
	// )}</span><span class="green-bold gjs-readonly">${_e('mapping')}</span>`;
	const mapping = `<span class="blue-bold gjs-readonly">${_e('mapping')}</span>`;
	const goals = `<span class="green-bold gjs-readonly">${_e('goals')}</span>`;
	resultHtml = resultHtml.replace(/{WHAT_IS_GM_TITLE}/g, _e('what_is_goalsmapping'));
	resultHtml = resultHtml.replace(/{WHAT_IS_GM_DESC}/g, _e('what_is_gm_desc'));
	resultHtml = resultHtml.replace(/{GOALS}/g, goals);
	resultHtml = resultHtml.replace(/{MAPPING}/g, mapping);
	const disclaimerClass = locale === 'th-TH' ? 'disclaimer-th' : 'disclaimer';
	resultHtml = resultHtml.replace(
		/{GM_DISCLAIMER_BLOCK}/g,
		`<div class="${disclaimerClass}"
		 		data-gjs-type="unchangeable"
        data-gjs-removable="false"
        data-gjs-copyable="false"
        data-gjs-draggable="false">
        ${_e('gm_disclaimer_block')}
    </div>`
	);

	return resultHtml;
};

export const applyDataIntoHtml = (html, template, adviserInfo) => {
	console.log('applyDataIntoHtml', template);
	console.log('adviserInfo: ', adviserInfo);
	if (template.includes('report')) {
		return applyDataIntoCoverHtml(html);
	}
	if (template.includes('ebookintro')) {
		return applyDataIntoEbookIntroHtml(html, template, adviserInfo);
	}
	const mergedHtml = applySampleDataIntoWebsiteHtml(html, template, adviserInfo);
	const finalHtml = applyAdviserDataIntoWebsiteHtml(mergedHtml, template, adviserInfo);
	return finalHtml;
};

const initializeEbookIntroComponents = () => {
	console.log('initializeEbookIntroComponents');
	// checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
	// 	const allGjsGM = getElementsFromIframe('.gjs-frame', '[data-gm]');
	// 	console.log('initializeEbookIntroComponents', allGjsGM);
	// 	allGjsGM.forEach(element => {
	// 		try {
	// 			const json = JSON.parse(element.dataset.gm);
	// 			const gjsComponent = findGrapesJSComponent(`#${element.id}`);
	// 			console.log('initializeEbookIntroComponents each', json, element.id, gjsComponent);
	// 			gjsComponent.set({
	// 				copyable: json.copyable
	// 				// editable: false,
	// 				// removable: false,
	// 				// draggable,
	// 				// selectable: draggable,
	// 				// hoverable: draggable,
	// 				// stylable: false
	// 				// propagate: ['editable', 'removable', 'draggable', 'copyable', 'selectable',
	// 				// 'stylable', 'hoverable']
	// 			});
	// 			// if (json.copyable) {
	// 			// 	component.set({
	// 			// 		editable: false,
	// 			// 		removable: false,
	// 			// 		draggable,
	// 			// 		selectable: draggable,
	// 			// 		hoverable: draggable,
	// 			// 		copyable: false,
	// 			// 		stylable: false
	// 			// 		// propagate: ['editable', 'removable', 'draggable', 'copyable', 'selectable',
	// 			// 		// 'stylable', 'hoverable']
	// 			// 	});
	// 			// }
	// 		} catch (e) {
	// 			console.log(e);
	// 		}
	// 	});
	// });

	setAllChildComponentsReadOnly('.gjs-readonly');
};

export const changeTemplate = async (
	selectedTemplate,
	{ forceReset = false, editor = window.grapesjs },
	adviserInfo = {}
) => {
	window.grapesjsLoadTemplateCompleted = false;
	removeAllFullScreenStyles();

	console.log('TCL: changeTemplate -> evt', selectedTemplate);
	window.selectedTemplate = selectedTemplate;

	let responseData;
	if (forceReset) {
		const html = await getTemplateHTML(selectedTemplate);
		const realData = applyDataIntoHtml(html, selectedTemplate, adviserInfo);
		editor.setComponents(realData);

		// Apply Extra Data to Template
		applyExtraDataToEditorRight(adviserInfo);

		// Ebook Intro, set readonly
		if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_EBOOK_INTRO) {
			initializeEbookIntroComponents();
		}

		// Clear GrapesJS CSSComposer too
		window.grapesjs.CssComposer.clear();
	} else {
		// First check template details from DB
		await loadTemplate();
	}

	setDataGMUserTypeToHTML();

	setTimeout(() => {
		window.grapesjsLoadTemplateCompleted = true;

		addJSToTemplate();
		try {
			setTimeout(() => {
				if (window.grapesjs.Canvas.getWindow().runJS) {
					window.grapesjs.Canvas.getWindow().runJS(
						window.selectedTemplate,
						process.env.REACT_APP_BASE_API_URL
					);

					// Make testimonials section readonly
					setAllChildComponentsReadOnly('.testimonials', ['header']);
				}

				// Auto click first dom elements to show settings
				const dc = window.grapesjs.DomComponents;
				if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
					window.grapesjs.select(dc.getComponents().at(0));
				} else {
					// should default choose cover-page-image
					window.grapesjs.select(dc.getComponents().at(1));
				}
			}, 1500);
		} catch (error) {
			console.log(error);
		}
	}, 1000);

	return responseData;
};

const initializeReportCoverComponents = () => {
	const blocks = findGrapesJSComponents('.block');
	blocks.forEach(component => {
		component.set({
			selectable: false,
			hoverable: false,
			removable: false,
			propagate: ['removable']
		});
	});
	const blankSpaces = findGrapesJSComponents('.blank-space');
	blankSpaces.forEach(component => setReadOnlyComponent(component, false));
};

export const loadTemplateIntoEditor = async (template, editor = window.grapesjs) => {
	console.log('loadTemplateIntoEditor', template);
	addRemoveGrapesJSButtons();
	const responseData = await changeTemplate(template.id, { editor });
	if (template.type === BRANDING_TYPE.TYPE_REPORT_COVER) {
		initializeReportCoverComponents();
	} else if (template.type === BRANDING_TYPE.TYPE_EBOOK_INTRO) {
		initializeEbookIntroComponents();
	}
	return responseData;
};
